import React from "react";
import PropTypes from "prop-types";

import HumanComments from "./HumanComments";

import HumanForm from "./HumanForm";

const HumanColumn = ({ human }) => {
  return (
    <>
      <HumanForm human={human} />
      <div className="my-2 mb-24 lg:pb-0">
        <HumanComments human={human} />
      </div>
    </>
  );
};

HumanColumn.propTypes = {
  human: PropTypes.object.isRequired,
};

export default HumanColumn;
